import useTranslation from 'next-translate/useTranslation';
import Trans from 'next-translate/Trans';

export function PrivacyLabel() {
  const { t } = useTranslation();
  return (
    <Trans
      i18nKey='common:Please accept our Privacy Policy'
      components={{
        a: <a className='link' href={t('common:/privacy')} />,
      }}
    />
  );
}
